import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { INITIALIZE_DATAKEY } from '../actions/types';
import { selectResourceForKey } from '../selectors';
import { FormProps, IncompleteDeclaration, OneFormReduxState, ReduxState, ValidationResults } from '../types';
import { processDefaultOptions, useCommonForm } from './common';

const useForm = <FieldNames extends string>(
	dataKey: string,
	_declaration: IncompleteDeclaration<FieldNames>,
): FormProps<FieldNames> => {
	const declaration = processDefaultOptions(_declaration);
	const selector = useMemo(() => selectResourceForKey(dataKey), [dataKey]);
	const resource = useSelector((state: ReduxState) => selector(state)) as OneFormReduxState<FieldNames> & {
		validation: ValidationResults<FieldNames>;
	};
	const dispatch = useDispatch();
	const _isInitialized = Object.keys(resource.model).length > 0;
	useEffect(() => {
		if (_isInitialized && _declaration.resetOnMount) {
			dispatch({
				type: INITIALIZE_DATAKEY,
				payload: { dataKey, initialModel: declaration.initialModel },
			});
			resource.model = declaration.initialModel;
		}
		// TODO: figure out if this is really necessary
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return useCommonForm(dataKey, declaration, resource, dispatch);
};

export default useForm;
